import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import React, { useRef, useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import { useNavigate } from 'react-router-dom';
import introOne from '../../assets/images/intro/intro-1.webp';
import introTwo from '../../assets/images/intro/intro-2.webp';
import introThree from '../../assets/images/intro/intro-3.webp';
import introFour from '../../assets/images/intro/intro-4.webp';
import Button from '../../components/ui/Button';
import { Routes } from '../../constants/RouteConstants';
import { saveToStorage } from '../../utils/Helper';

type CarouselRef = {
    next: () => void;
    current: {
        index: number;
    };
};

const Intro: React.FC = () => {
    const carouselRef = useRef<CarouselRef | any>(null);
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(0);
    const [isLastSlide, setIsLastSlide] = useState(false);

    React.useEffect(() => {
        const images = [introOne, introTwo, introThree, introFour];

        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, []);

    const options = {
        loop: false,
        margin: 0,
        items: 1,
        nav: false,
        dots: true,
        autoplay: false,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        smartSpeed: 450,
        startPosition: activeIndex,
        onChanged: (event: any) => handleSlideChange(event),
    };

    const handleSlideChange = (event: any) => {
        const index = event.item.index;
        setActiveIndex(index);

        if (index === event.item.count - 1) {
            setIsLastSlide(true);
        } else {
            setIsLastSlide(false);
        }
    };

    const handleButtonClick = () => {
        if (isLastSlide) {
            saveToStorage({ key: 'is_intro_viewed', value: true })
            navigate(Routes.Login);
        } else if (carouselRef.current) {
            carouselRef.current.next();
        }
    };

    return (

        <main id="main-content" className='front-slider'>
            {!isLastSlide ?
                <a
                    className='cursor-pointer safe-area-skip-btn'
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            saveToStorage({ key: 'is_intro_viewed', value: true })
                            navigate(Routes.Login);
                        }
                    }}
                    onClick={() => {
                        saveToStorage({ key: 'is_intro_viewed', value: true })
                        navigate(Routes.Login);
                    }}
                >
                    Skip
                </a>
                : ''
            }
            <div className='front-slider-wrap'>
                <OwlCarousel ref={carouselRef} className='owl-theme' {...options}>
                    <div className='item slide-1'>
                        <div className='front-img'>
                            <img src={introOne} alt="Welcome to Justivide illustration" loading="eager" />
                        </div>
                        <div className='text-content'>
                            <div className='f-slider-ttl'>Welcome to Justivide!</div>
                            <p className='f-slider-para'>We believe in equality and in the dignity of all work.</p>
                        </div>
                    </div>
                    <div className='item slide-2'>
                        <div className='front-img'>
                            <img src={introTwo} alt="Chores and home repairs illustration" loading="eager" />
                        </div>
                        <div className='text-content'>
                            <div className='f-slider-ttl'>Make the Invisible Visible</div>
                            <p className='f-slider-para'>Assign and gain credit for cleaning, home repairs, and other chores.</p>
                        </div>
                    </div>
                    <div className='item slide-3'>
                        <div className='front-img'>
                            <img src={introThree} alt="Contributions tracking illustration" loading="eager" />
                        </div>
                        <div className='text-content'>
                            <div className='f-slider-ttl'>Recognize All Contributions</div>
                            <p className='f-slider-para'>Track expenses, hours of labor, and the opportunity costs that you've incurred.</p>
                        </div>
                    </div>
                    <div className='item slide-4'>
                        <div className='front-img'>
                            <img src={introFour} alt="Fair splitting illustration" loading="eager" />
                        </div>
                        <div className='text-content'>
                            <div className='f-slider-ttl'>Find Your Fair</div>
                            <p className='f-slider-para'>Split contributions in different ways, track payments, and view reports.</p>
                        </div>
                    </div>
                </OwlCarousel>
                <Button
                    className='com-btn'
                    type='button'
                    onClick={handleButtonClick}
                >
                    {isLastSlide ? 'Get Started' : 'Next'}
                </Button>
            </div>

        </main>
    );
};

export default Intro;